import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'id.staging.jobstreet.com',
    clientId: 'P5wskeiRo27KYCegQSne0LBGfLUo9O0g',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSTREET,
    contactUs: {
        en: 'https://id.jobstreet.com/contact-us/',
        id: 'https://id.jobstreet.com/id/contact-us/',
    },
    siteName: siteNames.candidate.jobstreet.id,
    zone: getZoneFromSite(siteNames.candidate.jobstreet.id),
    product: Product.SEEK,
};
//# sourceMappingURL=id_staging_jobstreet_com.js.map